var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.chartReady)?_c('EChart',{attrs:{"option":_vm.chartOption,"init-options":{ renderer: 'svg' }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }